module.exports = __webpack_public_path__ + "img/27.dd6c2c00.png";